import { gql } from 'src/__generated__';
import { type FetchDeviceProfilesQuery } from '@/__generated__/graphql';

export type Device = FetchDeviceProfilesQuery['devices'][number];

const FETCH_DEVICE_PROFILE = gql(`#graphql
	query FetchDeviceProfiles( $input: DevicesInput!, $pagination: PaginationInput) {
		devicesPageInfo(input: $input, pagination: $pagination) {
			totalCount
			limit
			count
			offset
			pageNumber
		}
		devices(input: $input, pagination: $pagination) {
			id
			profile {
				id
				name
				type: type
				sensor
				source
				sourceInfo
				organization {
					id
					name
				}
				project
				created
				dateAction
			}
			hardwareConfiguration {
				id
				account {
					id
					username
					name
					lastnames
				}
				images
				googleDriveUrl
				dateAction
				sensorLevelOption {
					id
					name
				}
				serialNumberLevel
				modbusIdLevel
				batchNumberLevelSensor
				sensorVelocityOption {
					id
					name
				}
				serialNumberVelocity
				modbusIdVelocity
				batchNumberVelocitySensor
				sensorFlowOption {
					id
					name
				}
				serialNumberFlow
				modbusIdFlow
				batchNumberFlowSensor
				energizationOption {
					id
					name
				}
				powerSupplyVoltageOption {
					id
					name
				}
				powerSupplyModel
				powerSupplySerialNumber
				powerSupplyBrand
				solarPanelsControllers
				numberSolarPanelsControllers
				quantityBattery
				modelBattery
				technologyOption {
					id
					name
				}
				batteryCapacityOption {
					id
					name
				}
				batteryVoltageOption {
					id
					name
				}
				quantitySun
				modelsSun
				watts
				numberSun
				cpuOption {
					id
					name
				}
				batchNumberCpu
				auxiliaryOption {
					id 
					name
				}
				numberAuxiliary
				batchNumberAuxiliary
				internetConnectionOption {
					id
					name
				}
				modelsConnectionOption {
					id
					name
				}
				imei
				approved
				mobileOperatorOption {
						id
						name
				}
				phoneNumber
				dataPlanMobileOption {
					id
					name
				}
				iccid
				antennaOption {
					id
					name
				}
				mac
				configurationIp
				administrator
				networkName
				observation
				lockNumber
				ip
				imageVersion
				idEmnify
				satellitalTypeOption { 
					id
					name
				}
				satellitalSv
				satellitalHv
				satellitalHardwareName
				satellitalSerialName
				codeNumberWidgetlord
				serialNumberWidgetlord
				batchNumberWidgetlord
				batchNumberSimCard
				usbExtraction
               configurationFile {
                 name
                 url
               }
			}
			deviceTypeMeasurement {
				level
				velocity
				flow
			}
			sensors {
				id
				type: type {
					id
					name
					label: label
				}
				configuration {
					sensorId
					batchNumber
					serialNumber
					modbusId
					sensorModelOption {
						id
						name
					}
				}
			}
		}
	}
`);

export default FETCH_DEVICE_PROFILE;
